import { State, Action, StateContext, createPropertySelectors, Selector } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';

import { ISportConfigModelAPI, ISportStateModel } from './sport.models';
import { FetchSportConfig, SetCurrentSport } from './sport.actions';
import { isSport, sportStateDefaults } from './sport.utils';
import { SportService } from './sport.service';

@Injectable()
@State<ISportStateModel>({
    name: sportStateDefaults.sliceName,
    defaults: sportStateDefaults.defaults
})
export class SportState {
    private readonly _sportService = inject(SportService);

    public static selectors = createPropertySelectors<ISportStateModel>(SportState);

    @Selector([SportState.selectors.sportConfig])
    public static sportRegulationPeriods(sportConfig: ISportConfigModelAPI | undefined): number | undefined {
        if (!sportConfig) {
            return;
        }

        return sportConfig.nbRegulationTimePeriods;
    }

    @Selector([SportState.selectors.sportConfig])
    public static overTimeDurations(sportConfig: ISportConfigModelAPI | undefined): string[] | undefined {
        if (!sportConfig) {
            return;
        }

        return sportConfig.overTimeDurations;
    }

    @Selector([SportState.selectors.sportConfig])
    public static gameClockGoesDown(sportConfig: ISportConfigModelAPI | undefined): boolean{
        if (!sportConfig) {
            return false;
        }

        return sportConfig.gameClockGoesDown;
    }

    @Action(SetCurrentSport)
    private _setCurrentSport(ctx: StateContext<ISportStateModel>, { sport }: SetCurrentSport) {
        if (!isSport(sport)) {
            throw new Error('Not a valid sport');
        }

        return ctx.patchState({
            currentSport: sport
        });
    }

    @Action(FetchSportConfig)
    private _fetchSportConfig(ctx: StateContext<ISportStateModel>) {
        return this._sportService.getSportConfig().pipe(
            map(config => {
                return ctx.patchState({
                    sportConfig: config
                });
            })
        );
    }
}
